import React from 'react';

type FormContainerProps = {
    children: any;
};

export const FormContainer: React.FunctionComponent<FormContainerProps> = ({children}): JSX.Element => {
    return (
        <div>
            <div className="clearfix">
                {children}
            </div>
        </div>
    );
};